export const LAW_HTML = `<h3>特定商取引法に基づく表記</h3>
<table>
  <tbody>
  <tr>
    <th>事業者の名称</th>
    <td>合同会社Co-nnect Inc.</td>
  </tr>
  <tr>
    <th>代表者名</th>
    <td>代表：関根有</td>
  </tr>
  <tr>
    <th>所在地</th>
    <td>
      〒103-0006 東京都中央区日本橋富沢町10-13 & WORK NIHONBASHI 5F
    </td>
  </tr>
  <tr>
    <th>役務の対価</th>
    <td>
      提案者（コンサルタント）が提案依頼者（企業）から提出された提案依頼に対し提案する際のシステム利用料は、案件予算額の1%となっております。
    </td>
  </tr>
  </tbody>
</table>

<h3>対価の支払い時期及び支払い方法</h3>
<table>
  <tbody>
  <tr>
    <th>支払い時期</th>
    <td>
      提案者（コンサルタント）は、提案依頼情報を閲覧する時点、また、提案することを決定し、提案内容をアップロードし提案依頼者（企業）に送信した時点で、当社にシステム利用料の支払い義務が生じます。
    </td>
  </tr>
  <tr>
    <th>支払い方法</th>
    <td>
      サービス利用者は請求書もしくはGMOの提供する決済システム上で当社宛にシステム利用料の支払いを行ないます。
      <br />
      請求書での支払いの場合、支払い期限は月末締め翌月末支払いとなります。
    </td>
  </tr>
  <tr>
    <th>役務の提供時期</th>
    <td>
      役務である提案依頼者と提案者（コンサルタント）のマッチングサービスは随時提供しています。
    </td>
  </tr>
  <tr>
    <th>返金について</th>
    <td>
      提案者（コンサルタント）の都合によるキャンセル（閲覧後の閲覧取りやめ、提案後の提案取りやめ）の場合、返金を行いません。
    </td>
  </tr>
  <tr>
    <th>連絡先</th>
    <td>support@proffit.jp</td>
  </tr>
  </tbody>
</table>`;
